module.exports = __webpack_public_path__ + "static/media/facebook-choose.861850cd.svg";